module.exports = __webpack_public_path__ + "static/media/bg-contact-us.a48e3857.png";